import React from 'react'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { LoadingPlaceholder } from '@mobi/component-library/Misc/LoadingPlaceholder'
import { radius } from '@mobi/component-library/Foundations'

export const SkeletonLoader = () => {
  return (
    <Flex justifyContent='space-between' alignItems='center'>
      <Flex>
        <LoadingPlaceholder width='3rem' height='3rem' borderRadius={radius.lgx5} margin='0.5rem' />
        <LoadingPlaceholder width='3rem' height='3rem' borderRadius={radius.lgx5} margin='0.5rem' />
        <LoadingPlaceholder width='3rem' height='3rem' borderRadius={radius.lgx5} margin='0.5rem' />
      </Flex>
      <Flex justifyContent='flex-end' alignItems='center'>
        <LoadingPlaceholder width='3rem' height='3rem' borderRadius={radius.lgx5} margin='0.5rem' />
        <LoadingPlaceholder width='4rem' height='3rem' borderRadius={radius.lgx3} margin='0.5rem' />
      </Flex>
    </Flex>
  )
}
